import styled from 'styled-components';
import { getIconColor, getIconSize } from '../utils/iconHelpers';

export const StyledIcon = styled.i`
  color: ${props => getIconColor(props.theme, props.color)};
  font-size: ${props => getIconSize(props.size)};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease-in-out;

  @media (max-width: 375px) {
    font-size: ${props => getIconSize(props.size === 'xs' ? 'xs' : 'sm')};
  }
`;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Icon/components/IconStyles.js